import React from 'react';
import SocialButtons from "js/components-v2/common/Footer/SocialButtons";
import FooterLinks from "js/components-v2/common/Footer/FooterLinks";
import FooterCopyright from "js/components-v2/common/Footer/FooterCopyright";

const Footer = () => {
  const handlerToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="pod-footer">
      <button className="scroll-top" onClick={handlerToTop}>
        TOP ^
      </button>
      <div className="footer-container pod-container">
        <div className="d-md-flex justify-content-md-between align-items-md-start">
          <div className="d-md-none">
            <img src="/images/v2/logo-white.svg" alt="PayOnDelivery" className="logo-footer"/>

            <SocialButtons/>
          </div>
          <div className="links">
            <div className="d-none d-md-block pod-logo mb-5">
              <img src="/images/v2/logo-white.svg" alt="PayOnDelivery" className="logo-footer"/>
              <FooterCopyright className="d-none d-md-block mt-1"/>
            </div>
            <FooterLinks/>
          </div>
          <div className="d-none d-md-block buttons">
            <SocialButtons/>
          </div>
        </div>
        <FooterCopyright className="d-md-none"/>
      </div>
    </footer>
  )
};

export default Footer;
